<template>
  <div class="home">
    <van-collapse v-model="activeNames" class="dym_collapse" accordion>
      <van-collapse-item name="1" :title="`入库审核：${noIncomingAuditList.length || 0}笔未审核`">
        <div class="home">
          <van-popup v-model="show" get-container="body" :style="{ height: '100%', width: '100%' }" :closeable="true">
            <div >
              <div class="plr20 bggrey ft28" style="height: 8vh; line-height: 8vh; font-weight: bold;">
                气瓶入库信息
              </div>
              <van-cell-group class="plr20">
                <van-cell title="登记单位：" :value="showForm.ownerDeptName" />
                <van-cell title="填充介质：" :value="showForm.gasTypeName" />
                <van-cell title="入库数量：" :value="showForm.incomingCount" />
                <van-cell title="入库人：" :value="showForm.incomingPersonName" />
                <van-cell title="入库时间" :value="showForm.incomingTime" />
              </van-cell-group>
              <div class="plr20 bggrey ft28" style="height: 8vh; font-weight: bold; line-height: 8vh">
                入库列表
              </div>
              <!--入库列表-->
              <div class="itme-wrapper" v-if="showForm.bottleList">
                <div v-for="(item, index) in showForm.bottleList" :key="index" style="padding: 0 0 10px; position: relative">
                  <div class="items">
                    <span class="item-name">气瓶编号：</span>
                    <span class="item-value">{{ item.bottleId || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">下检年月：</span>
                    <span class="item-value">{{ item.nextCheckDate || '-' }}</span>
                  </div>
                </div>
              </div>            
            </div>
              <div style="position: fixed; bottom: 10px;display: flex; justify-content: space-around;text-align: center" class="flex w100">              
                <van-button type="primary" class="w40 tc" @click="confirmIncomingRecord(showForm)">入库通过</van-button>
                <van-button type="danger" class="w40 tc" @click="refuseIncomingRecord(showForm)">审核拒绝</van-button>
              </div>            
          </van-popup>

          <van-tabs @click="initIncomingContent" color="#4597ff">
            <van-tab title="待审核">
              <van-pull-refresh v-model="isLoading" @refresh="noIncomingAuditRefresh(false)">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了"
                    @load="onNoIncomingAuditLoad">
                    <div v-for="(item, index) in noIncomingAuditList" :key="index" style="margin-top: 0px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 1px">
                          <div class="history-item">
                            <span>登记单位：</span>
                            <span>{{ item.ownerDeptName }}</span>
                          </div>
                          <div class="history-item">
                            <span>填充介质：</span>
                            <span>{{ item.gasTypeName }}</span>
                          </div>
                          <div class="history-item">
                            <span>入库数量：</span>
                            <span>{{ item.incomingCount }}</span>
                          </div>
                          <div class="history-item">
                            <span>入库人：</span>
                            <span>{{ item.incomingPersonName }}</span>
                          </div>
                          <div class="history-item">
                            <span>入库时间：</span>
                            <span>{{ item.incomingTime }}</span>
                          </div>
                        </div>
                        <van-button plain type="info" size="small" class="userBtn1"
                          @click="auditIncomingRecord(item)">审核</van-button>
                      </div>
                    </div>
                  </van-list>
                </div>
              </van-pull-refresh>
            </van-tab>
            <van-tab title="已审核">
              <van-pull-refresh v-model="isLoading" @refresh="incomingAuditRefresh(false)">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了"
                    @load="incomingAuditLoad">
                    <div v-for="(item, index) in incomingAuditList" :key="index" style="margin-top: 0px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 1px">
                          <div class="history-item">
                            <span>登记单位：</span>
                            <span>{{ item.ownerDeptName }}</span>
                          </div>
                          <div class="history-item">
                            <span>填充介质：</span>
                            <span>{{ item.gasTypeName }}</span>
                          </div>
                          <div class="history-item">
                            <span>入库数量：</span>
                            <span>{{ item.incomingCount }}</span>
                          </div>
                          <div class="history-item">
                            <span>入库人：</span>
                            <span>{{ item.incomingPersonName }}</span>
                          </div>
                          <div class="history-item">
                            <span>入库时间：</span>
                            <span>{{ item.incomingTime }}</span>
                          </div>
                        </div>
                        <div class="hisotry-right">                          
                          <van-button plain type="info" size="small" class="userBtn"
                                                    @click="getIncomingDetail(item)">详情</van-button> 
                          <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />
                          <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png" alt="" />
                        </div>
                        <!-- <van-button plain type="info" size="small" class="userBtn"
                                                    @click="getDetail(item)">详情</van-button> -->
                      </div>
                    </div>
                  </van-list>
                </div>
              </van-pull-refresh>
            </van-tab>
          </van-tabs>
        </div>
      </van-collapse-item>
      <van-collapse-item name="2" :title="`领用审核：${noBorrowAuditList.length || 0}笔未审核`">
        <div class="home">
          <van-popup v-model="borrowShow" get-container="body" :style="{ height: '100%', width: '100%' }"
            :closeable="true">
            <div>
              <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh; font-weight: bold;">
                气瓶领用信息
              </div>
              <van-cell-group class="plr20">
                <van-cell title="填充介质：" :value="showForm.gasTypeName" />
                <van-cell title="领用数量：" :value="showForm.borrowCount" />
                <van-cell title="领用人：" :value="showForm.borrowerName" />
                <van-cell title="领用时间" :value="showForm.borrowDate" />
              </van-cell-group>
              <div class="plr20 bggrey ft28" style="height: 8vh; font-weight: bold; line-height: 8vh">
                领用列表
              </div>
              <!--领用列表-->
              <div class="itme-wrapper" v-if="showForm.bottleList">
                <div v-for="(item, index) in showForm.bottleList" :key="index" style="padding: 0 0 10px; position: relative">
                  <div class="items">
                    <span class="item-name">气瓶编号：</span>
                    <span class="item-value">{{ item.bottleId || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">入库时间：</span>
                    <span class="item-value">{{ item.incomingTime || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">下检年月：</span>
                    <span class="item-value">{{ item.nextCheckDate || '-' }}</span>
                  </div>
                </div>
              </div>              
              <div style="position: fixed; bottom: 10px;display: flex; justify-content: space-around;text-align: center" class="flex w100">              
                <van-button type="primary" class="w40 tc" @click="confirmBorrowRecord(showForm)">领用确认</van-button>
                <van-button type="danger" class="w40 tc" @click="refuseBorrowRecord(showForm)">审核拒绝</van-button>
              </div>
            </div>
          </van-popup>
          <van-tabs @click="initBorrowContent" color="#4597ff">
            <van-tab title="待审核">
              <van-pull-refresh v-model="isLoading" @refresh="noBorrowAuditRefresh(false)">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了"
                    @load="onNoBorrowAuditLoad">
                    <div v-for="(item, index) in noBorrowAuditList" :key="index" style="margin-top: 0px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 1px">
                          <div class="history-item">
                            <span>填充介质：</span>
                            <span>{{ item.gasTypeName }}</span>
                          </div>
                          <div class="history-item">
                            <span>领用数量：</span>
                            <span>{{ item.borrowCount }}</span>
                          </div>
                          <div class="history-item">
                            <span>领用人：</span>
                            <span>{{ item.borrowerName }}</span>
                          </div>
                          <div class="history-item">
                            <span>领用时间：</span>
                            <span>{{ item.borrowDate }}</span>
                          </div>
                        </div>

                        <!-- <van-button plain type="info" size="small" class="userBtn"
                                                    @click="getDetail(item)">详情</van-button> -->
                        <van-button plain type="info" size="small" class="userBtn1"
                          @click="auditBorrowRecord(item)">审核</van-button>
                      </div>
                    </div>
                  </van-list>
                </div>
              </van-pull-refresh>
            </van-tab>
            <van-tab title="已审核">
              <van-pull-refresh v-model="isLoading" @refresh="borrowAuditRefresh(false)">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="borrowAuditLoad">
                    <div v-for="(item, index) in borrowAuditList" :key="index" style="margin-top: 0px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 1px">
                          <div class="history-item">
                            <span>填充介质：</span>
                            <span>{{ item.gasTypeName }}</span>
                          </div>
                          <div class="history-item">
                            <span>领用数量：</span>
                            <span>{{ item.borrowCount }}</span>
                          </div>
                          <div class="history-item">
                            <span>领用人：</span>
                            <span>{{ item.borrowerName }}</span>
                          </div>
                          <div class="history-item">
                            <span>领用时间：</span>
                            <span>{{ item.borrowDate }}</span>
                          </div>
                        </div>
                        <div class="hisotry-right">
                          <van-button plain type="info" size="small" class="detailBtn"
                          @click="getBorrowDetail(item)">详情</van-button>
                          <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />
                          <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png" alt="" />
                        </div>
                       
                      </div>
                    </div>
                  </van-list>
                </div>
              </van-pull-refresh>
            </van-tab>
          </van-tabs>
        </div>
      </van-collapse-item>
      <van-collapse-item name="3" :title="`归还审核：${noReturnAuditList.length || 0}笔未审核`">
        <div class="home">
          <van-popup v-model="returnShow" get-container="body" :style="{ height: '100%', width: '100%' }"
            :closeable="true">
            <div>
              <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh; font-weight: bold;">
                气瓶归还信息
              </div>
              <van-cell-group class="plr20">
                <van-cell title="归还部门：" :value="showForm.sysDeptName" />
                <van-cell title="归还数量：" :value="showForm.returnCount" />                
                <van-cell title="归还人：" :value="showForm.returnByName" />
                <van-cell title="归还时间" :value="showForm.returnTime" />
              </van-cell-group>
              <div class="plr20 bggrey ft28" style="height: 8vh; font-weight: bold; line-height: 8vh">
                归还列表
              </div>
              <!--归还列表-->
              <div class="itme-wrapper" v-if="showForm.bottleList">
                <div v-for="(item, index) in showForm.bottleList" :key="index" style="padding: 0 0 10px; position: relative">
                  <div class="items">
                    <span class="item-name">气瓶编号：</span>
                    <span class="item-value">{{ item.bottleId || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">领用人：</span>
                    <span class="item-value">{{ item.borrowerName || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">领用时间：</span>
                    <span class="item-value">{{ item.borrowDate || '-' }}</span>
                  </div>
                </div>
              </div>              
              <div style="position: fixed; bottom: 10px;display: flex; justify-content: space-around;text-align: center" class="flex w100">    
                <van-button type="primary" class="w40 tc" @click="confirmReturnRecord(showForm)">归还确认</van-button>
                <van-button type="danger" class="w40 tc" @click="refuseReturnRecord(showForm)">审核拒绝</van-button>
     
              </div>
            </div>
          </van-popup>
          <van-tabs @click="initReturnContent" color="#4597ff">
            <van-tab title="待审核">
              <van-pull-refresh v-model="isLoading" @refresh="noReturnAuditRefresh(false)">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了"
                    @load="onNoReturnAuditLoad">
                    <div v-for="(item, index) in noReturnAuditList" :key="index" style="margin-top: 0px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 1px">
                          <div class="history-item">
                            <span>归还数量：</span>
                            <span>{{ item.returnCount }}</span>
                          </div>
                          <div class="history-item">
                            <span>归还人：</span>
                            <span>{{ item.returnByName }}</span>
                          </div>
                          <div class="history-item">
                            <span>归还时间：</span>
                            <span>{{ item.returnTime }}</span>
                          </div>
                        </div>
                        <div class="hisotry-right">
                          <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />
                          <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png" alt="" />
                        </div>                       
                        <van-button plain type="info" size="small" class="userBtn1"
                          @click="auditReturnRecord(item)">审核</van-button>
                      </div>
                    </div>
                  </van-list>
                </div>
              </van-pull-refresh>
            </van-tab>
            <van-tab title="已审核">
              <van-pull-refresh v-model="isLoading" @refresh="returnAuditRefresh(false)">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="returnAuditLoad">
                    <div v-for="(item, index) in returnAuditList" :key="index" style="margin-top: 0px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 1px">
                          <div class="history-item">
                            <span>归还数量：</span>
                            <span>{{ item.returnCount }}</span>
                          </div>
                          <div class="history-item">
                            <span>归还人：</span>
                            <span>{{ item.returnByName }}</span>
                          </div>
                          <div class="history-item">
                            <span>归还时间：</span>
                            <span>{{ item.returnTime }}</span>
                          </div>
                        </div>
                        <div class="hisotry-right">
                          <van-button plain type="info" size="small" class="detailBtn"
                          @click="getReturnDetail(item)">详情</van-button>
                          <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />
                          <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </van-list>
                </div>
              </van-pull-refresh>
            </van-tab>
          </van-tabs>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!--详情展示-->
    <van-popup v-model="borrowDetailShow" get-container="body" :style="{ height: '100%', width: '100%' }"
            :closeable="true">
            <div>
              <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh; font-weight: bold;">
                气瓶领用信息
              </div>
              <van-cell-group class="plr20">
                <van-cell title="填充介质：" :value="showForm.gasTypeName" />
                <van-cell title="领用数量：" :value="showForm.borrowCount" />
                <van-cell title="领用人：" :value="showForm.borrowerName" />
                <van-cell title="领用时间" :value="showForm.borrowDate" />
              </van-cell-group>
              <div class="plr20 bggrey ft28" style="height: 8vh; font-weight: bold; line-height: 8vh">
                领用列表
              </div>
              <!--领用列表-->
              <div class="itme-wrapper" v-if="showForm.bottleList">
                <div v-for="(item, index) in showForm.bottleList" :key="index" style="padding: 0 0 10px; position: relative">
                  <div class="items">
                    <span class="item-name">气瓶编号：</span>
                    <span class="item-value">{{ item.bottleId || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">入库时间：</span>
                    <span class="item-value">{{ item.incomingTime || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">下检年月：</span>
                    <span class="item-value">{{ item.nextCheckDate || '-' }}</span>
                  </div>
                </div>
              </div>              
              <div style="position: fixed; bottom: 10px;display: flex; justify-content: space-around;text-align: center" class="flex w100">              
                <van-button type="primary" class="w100 tc" @click="borrowDetailShow=false">关闭</van-button>                
              </div>
            </div>
          </van-popup>
          <van-popup v-model="incomingDetailShow" get-container="body" :style="{ height: '100%', width: '100%' }" :closeable="true">
            <div >
              <div class="plr20 bggrey ft28" style="height: 8vh; line-height: 8vh; font-weight: bold;">
                气瓶入库信息
              </div>
              <van-cell-group class="plr20">
                <van-cell title="登记单位：" :value="showForm.ownerDeptName" />
                <van-cell title="填充介质：" :value="showForm.gasTypeName" />
                <van-cell title="入库数量：" :value="showForm.incomingCount" />
                <van-cell title="入库人：" :value="showForm.incomingPersonName" />
                <van-cell title="入库时间" :value="showForm.incomingTime" />
              </van-cell-group>
              <div class="plr20 bggrey ft28" style="height: 8vh; font-weight: bold; line-height: 8vh">
                入库列表
              </div>
              <!--入库列表-->
              <div class="itme-wrapper" v-if="showForm.bottleList">
                <div v-for="(item, index) in showForm.bottleList" :key="index" style="padding: 0 0 10px; position: relative">
                  <div class="items">
                    <span class="item-name">气瓶编号：</span>
                    <span class="item-value">{{ item.bottleId || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">下检年月：</span>
                    <span class="item-value">{{ item.nextCheckDate || '-' }}</span>
                  </div>
                </div>
              </div>            
            </div>
              <div style="position: fixed; bottom: 10px;display: flex; justify-content: space-around;text-align: center" class="flex w100">              
                <van-button type="primary" class="w100 tc" @click="incomingDetailShow=false">关闭</van-button>                
              </div>            
          </van-popup>
          <van-popup v-model="returnDetailShow" get-container="body" :style="{ height: '100%', width: '100%' }"
            :closeable="true">
            <div>
              <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh; font-weight: bold;">
                气瓶归还信息
              </div>
              <van-cell-group class="plr20">
                <van-cell title="归还部门：" :value="showForm.sysDeptName" />
                <van-cell title="归还数量：" :value="showForm.returnCount" />                
                <van-cell title="归还人：" :value="showForm.returnByName" />
                <van-cell title="归还时间" :value="showForm.returnTime" />
              </van-cell-group>
              <div class="plr20 bggrey ft28" style="height: 8vh; font-weight: bold; line-height: 8vh">
                归还列表
              </div>
              <!--归还列表-->
              <div class="itme-wrapper" v-if="showForm.bottleList">
                <div v-for="(item, index) in showForm.bottleList" :key="index" style="padding: 0 0 10px; position: relative">
                  <div class="items">
                    <span class="item-name">气瓶编号：</span>
                    <span class="item-value">{{ item.bottleId || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">领用人：</span>
                    <span class="item-value">{{ item.borrowerName || '-' }}</span>
                  </div>
                  <div class="items">
                    <span class="item-name">领用时间：</span>
                    <span class="item-value">{{ item.borrowDate || '-' }}</span>
                  </div>
                </div>
              </div>              
              <div style="position: fixed; bottom: 10px;display: flex; justify-content: space-around;text-align: center" class="flex w100">    
                <van-button type="primary" class="w100 tc" @click="returnDetailShow=false">关闭</van-button>                
              </div>
            </div>
          </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Collapse, CollapseItem, Toast } from "vant";
//import wx from 'weixin-js-sdk';
Vue.use(Collapse);
Vue.use(CollapseItem);
import {
  incommingAuditHistory,
  incommingAudit,
  borrowAuditHistory,
  borrowAudit,
  returnAuditHistory,
  returnAudit,
  // getJsApiSdkParams,
} from "@/apis/api";

export default {
  data() {
    return {
      activeNames: ["1"],
      openId: localStorage.getItem("openId"),
      noIncomingAuditList: [],
      incomingAuditList: [],
      noBorrowAuditList: [],
      borrowAuditList: [],
      noReturnAuditList: [],
      returnAuditList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
      showForm: {},
      show: false,
      borrowShow: false,
      returnShow: false,
      borrowDetailShow:false,
      returnDetailShow:false,
      incomingDetailShow:false,
    };
  },
  mounted() {
    document.title = "审核";
    this.getNoIncomingAuditList(true);
    this.getincomingAuditList(true);
    this.getNoBorrowAuditList(true);
    this.getBorrowAuditList(true);
    this.getNoReturnAuditList(true);
    this.getReturnAuditList(true);    
  },
  methods: {

    //#region 入库未审核
    initIncomingContent(value) {
      this.currert = value;
      this.pageNo = 1;
      this.total = 0;
      this.isLoading = false;
      this.loading = false;
      this.finishedBottom = false;
      if (value == 0) {
        console.info("未审核");
        this.getNoIncomingAuditList(true);
      } else {
        console.info("已审核");
        this.getincomingAuditList(true);
      }
    },
    //isInit是否为初始化
    getNoIncomingAuditList(isInit) {
      this.noIncomingAuditRefresh(isInit);
    },
    //isInit是否为初始化
    noIncomingAuditRefresh(isInit) {
      this.pageNo = 1;
      this.isLoading = true;
      this.finishedBottom = false;
      console.info("noIncomingAuditRefresh===============");
      incommingAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 0,
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          if (!isInit) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            console.info("未审核数据：" + i);
          });
          this.noIncomingAuditList = res.result.records;
          this.total = res.result.total;
          if (this.noIncomingAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },

    onNoIncomingAuditLoad(e) {
      console.log("load------------------" + e);
      console.info("onNoIncomingAuditLoad=======================");
      if (this.isLoading) return;
      this.pageNo++;
      this.finishedBottom = false;
      incommingAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 0,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            console.info("未审核数据：" + i);
          });
          this.noIncomingAuditList = this.noIncomingAuditList.concat(
            res.result.records
          );
          this.total = res.result.total;
          if (this.noIncomingAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },
    //审核入库记录
    auditIncomingRecord(item) {
      this.show = true;
      this.showForm = item;
    },
    //入库审核通过
    confirmIncomingRecord(item) {
      incommingAudit({ incoming_id: item.id, status: 1 }).then((res) => {
        if (res.code == 200) {
          this.show = false;
          Toast("入库审核成功");
          this.noIncomingAuditRefresh(false);
        }
      });
    },
    //入库审核拒绝
    refuseIncomingRecord(item) {
      incommingAudit({ incoming_id: item.id, status: 2 }).then((res) => {
        if (res.code == 200) {
          this.show = false;
          Toast("入库拒绝");
          this.noIncomingAuditRefresh(false);
        }
      });
    },
    //#endregion 入库未审核

    //#region 入库已审核
    //isInit是否为初始化
    getincomingAuditList(isInit) {
      this.incomingAuditRefresh(isInit);
    },
    //isInit是否为初始化
    incomingAuditRefresh(isInit) {
      this.pageNo = 1;
      this.isLoading = true;
      this.finishedBottom = false;
      console.info("incomingAuditRefresh===============");
      incommingAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 1,
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          if (!isInit) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            console.info("已审核数据：" + i);
          });
          this.incomingAuditList = res.result.records;
          this.total = res.result.total;
          if (this.incomingAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },

    incomingAuditLoad(e) {
      console.log("load------------------");
      console.info("incomingAuditLoad=======================");
      if (this.isLoading) return;
      this.pageNo++;
      this.finishedBottom = false;
      incommingAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 1,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            console.info("已审核数据：" + i);
          });
          this.incomingAuditList = this.incomingAuditList.concat(
            res.result.records
          );
          this.total = res.result.total;
          if (this.incomingAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },
    //#endregion 入库已审核
    //#region 领用未审核
    initBorrowContent(value) {
      this.currert = value;
      this.pageNo = 1;
      this.total = 0;
      this.isLoading = false;
      this.loading = false;
      this.finishedBottom = false;
      if (value == 0) {
        console.info("未审核");
        this.getNoBorrowAuditList(true);
      } else {
        console.info("已审核");
        this.getBorrowAuditList(true);
      }
    },
    //isInit是否为初始化
    getNoBorrowAuditList(isInit) {
      this.noBorrowAuditRefresh(isInit);
    },
    //isInit是否为初始化
    noBorrowAuditRefresh(isInit) {
      this.pageNo = 1;
      this.isLoading = true;
      this.finishedBottom = false;
      console.info("noBorrowAuditRefresh===============");
      borrowAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 0,
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          if (!isInit) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            console.info("未审核数据：" + i);
          });
          this.noBorrowAuditList = res.result.records;
          this.total = res.result.total;
          if (this.noBorrowAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },

    onNoBorrowAuditLoad(e) {
      console.info("onNoBowworAuditLoad=======================");
      if (this.isLoading) return;
      this.pageNo++;
      this.finishedBottom = false;
      borrowAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 0,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            console.info("未审核数据：" + i);
          });
          this.noBorrowAuditList = this.noBorrowAuditList.concat(
            res.result.records
          );
          this.total = res.result.total;
          if (this.noBorrowAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },
    //领用记录
    auditBorrowRecord(item) {
      this.borrowShow = true;
      this.showForm = item;
    },
    confirmBorrowRecord(item) {
      borrowAudit({ borrow_id: item.id, status: 1 }).then((res) => {
        if (res.code == 200) {
          this.borrowShow = false;
          Toast("领用审核成功");
          this.noBorrowAuditRefresh(false);
        }
      });
    },
    refuseBorrowRecord(item) {
      borrowAudit({ borrow_id: item.id, status: 2 }).then((res) => {
        if (res.code == 200) {
          this.borrowShow = false;
          Toast("领用拒绝");
          this.noBorrowAuditRefresh(false);
        }
      });
    },
    //#endregion 领用未审核

    //#region 领用已审核
    //isInit是否为初始化
    getBorrowAuditList(isInit) {
      this.borrowAuditRefresh(isInit);
    },
    //isInit是否为初始化
    borrowAuditRefresh(isInit) {
      this.pageNo = 1;
      this.isLoading = true;
      this.finishedBottom = false;
      console.info("borrowAuditRefresh===============");
      borrowAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 1,
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          if (!isInit) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            console.info("已审核数据：" + i);
          });
          this.borrowAuditList = res.result.records;
          this.total = res.result.total;
          if (this.borrowAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },

    borrowAuditLoad(e) {
      console.info("borrowAuditLoad=======================");
      if (this.isLoading) return;
      this.pageNo++;
      this.finishedBottom = false;
      borrowAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 1,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            console.info("已审核数据：" + i);
          });
          this.borrowAuditList = this.borrowAuditList.concat(
            res.result.records
          );
          this.total = res.result.total;
          if (this.borrowAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },
    //#endregion 领用已审核

    //#region 归还未审核
    initReturnContent(value) {
      this.currert = value;
      this.pageNo = 1;
      this.total = 0;
      this.isLoading = false;
      this.loading = false;
      this.finishedBottom = false;
      if (value == 0) {
        console.info("未审核");
        this.getNoReturnAuditList(true);
      } else {
        console.info("已审核");
        this.getReturnAuditList(true);
      }
    },
    //isInit是否为初始化
    getNoReturnAuditList(isInit) {
      this.noReturnAuditRefresh(isInit);
    },
    //isInit是否为初始化
    noReturnAuditRefresh(isInit) {
      this.pageNo = 1;
      this.isLoading = true;
      this.finishedBottom = false;
      console.info("noReturnAuditRefresh===============");
      returnAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 0,
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          if (!isInit) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            console.info("未审核数据：" + i);
          });
          this.noReturnAuditList = res.result.records;
          this.total = res.result.total;
          if (this.noReturnAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },

    onNoReturnAuditLoad(e) {
      if (this.isLoading) return;
      this.pageNo++;
      this.finishedBottom = false;
      returnAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 0,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            console.info("未审核数据：" + i);
          });
          this.noReturnAuditList = this.noReturnAuditList.concat(
            res.result.records
          );
          this.total = res.result.total;
          if (this.noReturnAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },
    //审核领用记录
    auditReturnRecord(item) {
      this.returnShow = true;
      this.showForm = item;
    },
    confirmReturnRecord(item) {
      returnAudit({ return_id: item.id, status: 1 }).then((res) => {
        if (res.code == 200) {
          this.returnShow = false;
          Toast("归还审核成功");
          this.noReturnAuditRefresh(false);
        }
      });
    },
    refuseReturnRecord(item) {
      returnAudit({ return_id: item.id, status: 2 }).then((res) => {
        if (res.code == 200) {
          this.returnShow = false;
          Toast("审核拒绝");
          this.noReturnAuditRefresh(false);
        }
      });
    },
    //#endregion 入库未审核

    //#region 入库已审核
    //isInit是否为初始化
    getReturnAuditList(isInit) {
      this.returnAuditRefresh(isInit);
    },
    //isInit是否为初始化
    returnAuditRefresh(isInit) {
      this.pageNo = 1;
      this.isLoading = true;
      this.finishedBottom = false;
      console.info("returnAuditRefresh===============");
      returnAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 1,
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          if (!isInit) {
            Toast("刷新成功");
          }
          res.result.records.forEach((i, v) => {
            console.info("已审核数据：" + i);
          });
          this.returnAuditList = res.result.records;
          this.total = res.result.total;
          if (this.returnAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },

    returnAuditLoad(e) {
      console.info("returnAuditLoad=======================");
      if (this.isLoading) return;
      this.pageNo++;
      this.finishedBottom = false;
      returnAuditHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        dataType: 1,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          res.result.records.forEach((i, v) => {
            console.info("已审核数据：" + i);
          });
          this.returnAuditList = this.returnAuditList.concat(
            res.result.records
          );
          this.total = res.result.total;
          if (this.returnAuditList.length == this.total) {
            this.finishedBottom = true;
          }
        }
      });
    },
    //#endregion 入库已审核
    //#region审核详情
    getIncomingDetail(item) { //入库详情
      this.incomingDetailShow = true;
      this.showForm = item;
    },
    getBorrowDetail(item) { //领用详情
      this.borrowDetailShow = true;
      this.showForm = item;
    },
    getReturnDetail(item) { //归还详情
      this.returnDetailShow=true;
      this.showForm = item;
    },
    //#endregion

  },
};
</script>
<style lang="less" scoped>
body {
  height: 100%;
}

.dym_collapse {
  /deep/ .van-cell {
    background-color: #dbdada;
    font-weight: normal;
  }

  /deep/ .title-class {
    font-size: 26px;
    color: red;
  }

  /deep/ .van-cell__title {
    padding-left: 3vw;
  }

  /deep/.van-collapse-item__content {
    padding: 0;
    // color: #969799;
    // font-size: 0.37333rem;
    // line-height: 1.5;
    background-color: #f4f4f4;
  }

  .autoFixed {
    min-height: 50vh;
    padding: 0 30px;
    position: relative;

    .userBtn {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 94px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: none;
      border-radius: 5px;
      color: #4597ff;
    }

    .userBtn1 {
      position: absolute;
      right: 20px;
      top: 85px;
      width: 94px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: none;
      border-radius: 5px;
      color: #55aa7f;
    }
  }

  .main {
    box-sizing: content-box;
    background: #ffffff;
    width: 100%;
    border-radius: 5px;
    padding: 10px 24px;
    box-sizing: border-box;
    position: relative;
    margin-top: 20px;

    .history-item {
      margin-bottom: 15px;

      span {
        font-size: 28px;
        color: #333;
      }
    }

    .hisotry-right {
      position: absolute;
      right: 0px;
      top: 20px;

      img {
        width: 150px;
        height: 150px;
      }

      .quxiao {
        width: 150px;
        height: 130px;
      }
    }
  }
}

.itme-wrapper {
  padding: 0 16px 16px;
   height: 40vh;
   overflow: auto;

  .items {
    height: 50px;
    background: #faf9f9;
    padding: 0 10px;
    line-height: 50px;
  }
  .delete-btn {
    position: absolute;
    right: 10px;
    top: 75px;
    height: 50px;
  }
}

.detailBtn {
      position: absolute;
      right: 20px;
      top: 5px;
      width: 94px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: none;
      border-radius: 5px;
      color: #4597ff;
    }
</style>
